import { safeJoin } from './string-utils.ts';

export function getFullName(firstName: string | null | undefined, lastName: string | null | undefined) {
    return safeJoin([firstName, lastName], ' ');
}
